/**
 * Safe CSS Injection Utility
 * Replaces direct innerHTML manipulation for CSS styles
 */

/**
 * Safely inject CSS styles without using innerHTML
 * @param cssRules - CSS rules as a string
 * @param id - Optional unique ID for the style element
 * @returns Cleanup function to remove the style element
 */
export function injectStyles(cssRules: string, id?: string): () => void {
  const style = document.createElement('style');
  
  if (id) {
    style.id = id;
    // Remove existing style with same ID
    const existing = document.getElementById(id);
    if (existing) {
      existing.remove();
    }
  }
  
  // Use textContent instead of innerHTML for CSS
  style.textContent = cssRules;
  document.head.appendChild(style);
  
  // Return cleanup function
  return () => {
    if (style.parentNode) {
      style.parentNode.removeChild(style);
    }
  };
}

/**
 * Create scoped CSS rules for dialog overlays
 */
export function createDialogOverlayStyles(id: string): () => void {
  const cssRules = `
    .p-dialog-mask {
      background: rgba(0,0,0,0.15) !important;
    }
    .p-component-overlay {
      background: rgba(0,0,0,0.15) !important;
    }
  `;
  return injectStyles(cssRules, id);
}

/**
 * Create custom CSS rules with automatic cleanup
 * Use in React useEffect
 */
export function useCustomStyles(cssRules: string, id?: string): () => void {
  const cleanup = injectStyles(cssRules, id);
  return cleanup;
}
